"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateField = void 0;
var USER_PLACEHOLDER_LIST = ['VALUE', 'COMPANY', 'ORGANIZATION', 'MILESTONE', 'ACCOMPLISHMENT', 'OFFICE LOCATION', 'TEAM', 'DEPARTMENT', 'PRODUCT', 'SERVICE X', 'INSERT', 'INSIGHT', 'INTEREST'];
var AUTO_PLACEHOLDER_LIST = ['my-first-name', 'my-last-name', 'my-full-name', 'company', 'first-name', 'last-name', 'full-name', 'recipient-company', 'gl', 'gift-name', 'product-brand']; // TODO: refactor min, max lengths and validation messages to constants

var validateField = function validateField(value, name, min, max) {
  var _value$trim = value.trim(),
      length = _value$trim.length;

  if (!length) return "The ".concat(name, " needs to be filled in.");
  if (length <= min) return "The ".concat(name, " should be longer than ").concat(min, " chars.");
  if (length > max) return "The ".concat(name, " should not exceed ").concat(max, " chars."); // ...(...PLACEHOLDER...)...

  var userPlaceholderPattern = new RegExp("\\([\\w\\s!?]*(".concat(USER_PLACEHOLDER_LIST.join('|'), ")[\\w\\s!?]*\\)"));
  var hasUserPlaceholders = userPlaceholderPattern.test(value); // ...[placeholder]...

  var hasAutoPlaceholders = AUTO_PLACEHOLDER_LIST.some(function (placeholder) {
    return value.includes("[".concat(placeholder, "]"));
  });
  return hasAutoPlaceholders || hasUserPlaceholders ? 'Please remove placeholders' : undefined;
};

exports.validateField = validateField;